<div>
    <div class="loader__container">
        <div class="loader"></div>
    </div>
</div>